import CASL from '@/utils/constants/casl'

export default {
  path: 'process-pln',
  children: [
    {
      path: '',
      name: 'process-pln.list',
      meta: {
        action: 'read',
        subject: CASL.ACCESS.PROCESS
      },
      component: () => import('./list/ProcessPlnListPage.vue')
    }
  ]
}
